import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Navbar.css';
// ChangeAnoBaseModal removed — year control is inline in the navbar
import useDefaultModal from './hooks/useDefaultModal';
import DefaultModal from './modals/DefaultModal';
import ChangePasswordModal from './modals/ChangePasswordModal';
import { logout } from '../api/logout';

function Navbar({ toggleSidebar }) {
  const [user, setUser] = useState(null);
  const [entidade, setEntidade] = useState(null);
  const [vinculo, setVinculo] = useState(null);
  const [anoBase, setAnoBase] = useState(null);
  // modal removed: use inline controls to change year
  const [tabCount, setTabCount] = useState(1);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const [shouldRedirectLogin, setShouldRedirectLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const storedOptions = localStorage.getItem('vinculos');
  const parsedOptions = JSON.parse(storedOptions);
  
  const canChangeAnoBase = location.pathname === '/home' && tabCount === 1;
  const handleLogout = () => {
    const token = localStorage.getItem('token');
    if (token) { logout(token).catch(() => {}); }
    localStorage.clear();
    try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
    navigate('/');
  };

  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      navigate('/');
    }
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate('/');
    }
    const entidadeData = localStorage.getItem('entidade');
    if (entidadeData) {
      setEntidade(JSON.parse(entidadeData));
    }
    const vinculoData = localStorage.getItem('vinculo');
    if (vinculoData) {
      setVinculo(JSON.parse(vinculoData));
    }
    const anoBaseData = localStorage.getItem('anoBase');
    if (anoBaseData) {
      setAnoBase(anoBaseData);
    }
  }, [navigate]);

  // Impede troca de ano base se houver múltiplas abas abertas
  const handleTrocarAnoBase = () => {
    if (tabCount > 1) {
      showDefaultModal('error', 'O sistema está aberto em mais de uma aba do navegador. Feche as outras abas para trocar o ano base.');
      return;
    }
    // Modal removed: instruir usuário a usar os controles de ano na barra
    showDefaultModal('info', 'Use os controles de ano na barra superior para alterar o Ano Base.');
  };

  // Limites do ano base (mesma lógica do modal)
  const MIN_ANO = 2023;
  const MAX_ANO = new Date().getFullYear();

  const clampAno = (y) => Math.max(MIN_ANO, Math.min(MAX_ANO, y));

  // Troca o ano base diretamente (delta = -1 para anterior, +1 para próximo)
  const handleChangeAnoDirect = (delta) => {
    if (tabCount > 1) {
      showDefaultModal('error', 'O sistema está aberto em mais de uma aba do navegador. Feche as outras abas para trocar o ano base.');
      return;
    }

    const current = anoBase ? Number(anoBase) : MAX_ANO;
    const newYear = clampAno(current + delta);
    if (newYear === current) return;
    // Aplica mudança imediatamente e recarrega (sem navegar para /home)
    localStorage.setItem('anoBase', String(newYear));
    localStorage.setItem('ano', String(newYear));
    setAnoBase(String(newYear));
    window.location.reload();
  };

  // NOTE: removed shouldOpenAnoBaseModal auto-open behavior — modal opens directly
  // when requested, without redirecting the user to /home.

  // NOTE: removed pendingAnoBase flow to match uex behavior —
  // when the user changes the year we apply immediately and reload the page.

  // Se houver múltiplas abas abertas ao iniciar, exibe aviso e volta para login
  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      navigate('/');
    }
    if (tabCount > 1) {
      showDefaultModal('error', 'O sistema está aberto em mais de uma aba do navegador. Feche as outras abas para continuar.', () => setShouldRedirectLogin(true));
      return;
    }
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate('/');
    }
    const entidadeData = localStorage.getItem('entidade');
    if (entidadeData) {
      setEntidade(JSON.parse(entidadeData));
    }
    const vinculoData = localStorage.getItem('vinculo');
    if (vinculoData) {
      setVinculo(JSON.parse(vinculoData));
    }
    const anoBaseData = localStorage.getItem('anoBase');
    if (anoBaseData) {
      setAnoBase(anoBaseData);
    }
  }, [navigate]);

  useEffect(() => {
    if (shouldRedirectLogin) {
      navigate('/');
    }
  }, [shouldRedirectLogin, navigate]);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
        style={{ background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)' }}>
        <div className="container-fluid" style={{ position: 'relative' }}>
          {/* Botão Menu Sidebar */}
          {toggleSidebar && (
            <button
              className="btn btn-link text-white p-2 me-2"
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <i className="bi bi-list fs-4"></i>
            </button>
          )}

          {/* Logo */}
          <a href="/home" className="d-flex align-items-center navbar-brand">
            <img
              src="/assets/logo.png"
              alt="Logo"
              width="65"
              height="35"
              className="d-inline-block align-top me-2 me-lg-3 rounded-3"
            />
          </a>

          {/* Nome da entidade alinhado à esquerda - apenas desktop */}
          <div
            className="d-none d-lg-block ms-3"
            style={{
              zIndex: 0,
              pointerEvents: 'none',
              textAlign: 'left',
              whiteSpace: 'nowrap',
            }}
          >
            {entidade?.nome && (
              <span className="text-white fw-semibold" style={{ fontSize: '1em', letterSpacing: '0.05em' }}>
                {entidade.nome}
              </span>
            )}
          </div>

          {/* Botão Toggler para Mobile - Menu do Usuário */}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Menu do usuário"
          >
            <i className="bi bi-person-circle fs-5 text-white"></i>
          </button>
          
          {/* Dropdown do usuário para mobile (toggler) */}
          <ul
            className="dropdown-menu dropdown-menu-end text-white border border-secondary d-lg-none"
            style={{
              minWidth: '220px',
              background:
                'linear-gradient(135deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
            }}
          >
            <li>
              <div className="px-3 py-2">
                {user?.nome && (
                  <div className="text-white fw-semibold">{user.nome}</div>
                )}
                {entidade?.nome && (
                  <div className="text-white opacity-75 small">
                    {entidade.nome}
                  </div>
                )}
                {anoBase && (
                  <div className="d-flex align-items-center ano-control">
                    <button
                      className="ano-btn"
                      onClick={() => handleChangeAnoDirect(-1)}
                      aria-label="Ano anterior"
                      title="Ano anterior"
                    >
                      <i aria-hidden="true" className="bi bi-chevron-left"></i>
                    </button>
                    <div className="text-white opacity-75 small ano-value" aria-live="polite">
                      {anoBase}
                    </div>
                    <button
                      className="ano-btn"
                      onClick={() => handleChangeAnoDirect(1)}
                      aria-label="Ano posterior"
                      title="Ano posterior"
                    >
                      <i aria-hidden="true" className="bi bi-chevron-right"></i>
                    </button>
                  </div>
                )}
              </div>
            </li>
            <li>
              <hr className="dropdown-divider bg-white mx-2" />
            </li>
            {parsedOptions.length > 1 && (
              <li>
                <a
                  className="dropdown-item text-white"
                  href="/seleciona_entidade"
                >
                  <i className="bi bi-arrow-left-right me-2"></i>
                  Trocar Entidade
                </a>
              </li>
            )}
            {/* 'Trocar Ano Base' removido - agora usa controle direto na navbar */}
            <li>
              <button
                className="dropdown-item text-white"
                onClick={() => setShowChangePassword(true)}
              >
                <i className="bi bi-key me-2"></i>
                Alterar senha
              </button>
            </li>
            <li>
              <hr className="dropdown-divider bg-white mx-2" />
            </li>
            <li>
              <button
                className="dropdown-item text-white"
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-right me-2"></i>
                Sair
              </button>
            </li>
          </ul>

          {/* Conteúdo da Navbar - Apenas Desktop */}
          <div className="d-none d-lg-flex flex-row align-items-center gap-3 ms-auto">
            {/* Controle de Ano Base: [<][yyyy][>] - não editável, troca ano diretamente */}
            <div
              className="d-flex align-items-center ano-control"
              role="group"
              aria-label="Controle Ano Base"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'ArrowLeft') handleChangeAnoDirect(-1);
                if (e.key === 'ArrowRight') handleChangeAnoDirect(1);
              }}
            >
              <button
                className="ano-btn"
                onClick={() => handleChangeAnoDirect(-1)}
                aria-label="Ano anterior"
                title="Ano anterior"
              >
                <i aria-hidden="true" className="bi bi-chevron-left"></i>
              </button>
              <div
                className="text-white fw-semibold ano-value"
                aria-live="polite"
              >
                {anoBase || '----'}
              </div>
              <button
                className="ano-btn"
                onClick={() => handleChangeAnoDirect(1)}
                aria-label="Ano posterior"
                title="Ano posterior"
              >
                <i aria-hidden="true" className="bi bi-chevron-right"></i>
              </button>
            </div>
            {/* Informações do Usuário */}
            <div className="d-flex flex-column text-end">
              {user?.nome && (
                <span
                  className="text-white fw-semibold"
                  style={{ fontSize: '0.9em' }}
                >
                  {user.nome}
                </span>
              )}
            </div>

            {/* Dropdown do Usuário - Desktop */}
            <div className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle text-white d-flex align-items-center border-0 bg-transparent"
                id="userDropdownDesktop"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: 'pointer' }}
              >
                <i className="bi bi-person-circle fs-5"></i>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end text-white border border-secondary mt-2"
                style={{
                  minWidth: '220px',
                  background:
                    'linear-gradient(135deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                }}
              >
                {parsedOptions.length > 1 && (
                  <li>
                    <a
                      className="dropdown-item text-white"
                      href="/seleciona_entidade"
                    >
                      <i className="bi bi-arrow-left-right me-2"></i>
                      Trocar Entidade
                    </a>
                  </li>
                )}
                {/* 'Trocar Ano Base' removido do dropdown desktop */}
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={() => setShowChangePassword(true)}
                  >
                    <i className="bi bi-key me-2"></i>
                    Alterar senha
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider bg-white mx-2" />
                </li>
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Sair
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      {/* ChangeAnoBaseModal removed: year control is inline */}
      <DefaultModal {...setDefaultModal} />
      <ChangePasswordModal show={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </>
  );
}

export default Navbar;
